import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserContactRoutingModule } from './user-contact-routing.module';
import {
  UserContactComponent,
  ResetAvatarConfirmationComponent,
} from './components';
import { SharedModule } from '@app/shared/shared.module';
import { AuthModule } from '@adreno-common';

@NgModule({
  declarations: [UserContactComponent, ResetAvatarConfirmationComponent],
  imports: [
    CommonModule,
    UserContactRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AuthModule,
  ],
})
export class UserContactModule {}
